<div class="ibox detailed-view-ibox" *ngIf="settingsIncidentReportService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">{{settingsIncidentReportService.selectedItemData.name}}</div>
        <div style="font-size: 15px;"></div>
        <span class="close-detailed-view" (click)="settingsIncidentReportService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm" submittable autocomplete="off">
                <!-- Tab Control -->
                <div class="detailed-view-navigation">
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section"
                             (click)="setTab('general')"
                             [ngClass]="{'active': currentTab == 'general'}">
                            General
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section"
                             (click)="setTab('notifications')"
                             [ngClass]="{'active': currentTab == 'notifications'}">
                            Notifications
                        </div>
                    </div>
                </div>

                <div class="tabs-wrapper">
                    <!-- TAB GENERAL -->
                    <div class="tab animated fadeIn" *ngIf="currentTab === 'general'">
                        <input-field name="name"
                                     [ngModel]="settingsIncidentReportService.selectedItemData.name"
                                     [title]="'Name'"
                                     [tooltipText]="'Name'"
                                     (update)="onSubmit({name: form.value.name})">
                        </input-field>

                        <hr>

                        <!-- Buildings -->
                        <div class="m-b-xs" style="font-weight: bold;"><span>Apply to Buildings</span></div>
                        <multiselect-field name="buildings"
                                           [data]="settingsIncidentReportService.buldingsInMultiselectFormat"
                                           [amenityBuildingSelect]="true"
                                           [(ngModel)]="settingsIncidentReportService.selectedItemData.buildings"
                                           (update)="submitBuildings(form.value.buildings)">
                        </multiselect-field>

                        <div class="m-t-sm text-center" *ngIf="settingsIncidentReportService.selectedItemData.isCanDelete">
                            <button class="btn btn-default"
                                    type="button"
                                    (click)="deleteSetting()"
                                    [disabled]="disabledDelete">
                                Delete Setting
                            </button>
                        </div>
                    </div>

                    <!-- TAB NOTIFICATIONS -->
                    <div class="tab animated fadeIn" *ngIf="currentTab === 'notifications'">
                        <div class="settings-amenities-slider-container">
                            <span>Notify Staff</span>
                        </div>

                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsIncidentReportService.requestCreatedStaffCheckbox"
                                       name="requestCreatedStaffCheckbox"
                                       id="requestCreatedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'report_created')"
                                       (change)="submitNotificationsField()">
                                <label for="requestCreatedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'report_created') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'report_created')">
                                Incident Report Created
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsIncidentReportService.requestCreatedStaffCheckbox">
                            <multiselect-field name="createdStaffMultiselectArray"
                                               [data]="settingsIncidentReportService.userRoles"
                                               [(ngModel)]="settingsIncidentReportService.createdStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>

                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsIncidentReportService.requestModifiedStaffCheckbox"
                                       name="requestModifiedStaffCheckbox"
                                       id="requestModifiedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'report_updated')"
                                       (change)="submitNotificationsField()">
                                <label for="requestModifiedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'report_updated') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'report_updated')">
                                Incident Report Modified
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsIncidentReportService.requestModifiedStaffCheckbox">
                            <multiselect-field name="modifiedStaffMultiselectArray"
                                               [data]="settingsIncidentReportService.userRoles"
                                               [(ngModel)]="settingsIncidentReportService.modifiedStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>

                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsIncidentReportService.requestDeletedStaffCheckbox"
                                       name="requestDeletedStaffCheckbox"
                                       id="requestDeletedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'report_deleted')"
                                       (change)="submitNotificationsField()">
                                <label for="requestDeletedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'report_deleted') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'report_deleted')">
                                Incident Report Deleted
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsIncidentReportService.requestDeletedStaffCheckbox">
                            <multiselect-field name="deletedStaffMultiselectArray"
                                               [data]="settingsIncidentReportService.userRoles"
                                               [(ngModel)]="settingsIncidentReportService.deletedStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/detailed-view/detailed-view.component.html